async function EductorAddTest (testid, eductorid, percentageopen, inletoutlet, blowerintake, diameter, area, staticpressure, vp1, vp2, vp3, vp4, vp5, vp6, vp7, vp8, vp9, vp10, vp11, notes, gauge) {

    if (true) {

            let response;

            let params = {
                "@testID": testid,
                "@EductorID": eductorid,
                "@PercentageOpen": percentageopen,
                "@InletOutlet": inletoutlet,
                "@BlowerIntake": blowerintake,
                "@Diameter": diameter,
                "@Area": area,
                "@StaticPressure": staticpressure,
                "@VP1": vp1,
                "@VP2": vp2,
                "@VP3": vp3,
                "@VP4": vp4,
                "@VP5": vp5,
                "@VP6": vp6,
                "@VP7": vp7,
                "@VP8": vp8,
                "@VP9": vp9,
                "@VP10": vp10,
                "@VP11": vp11,
                "@Notes": notes,
                "@Gauge": gauge
              };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "77", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default EductorAddTest;